import { Box, Stack } from '@mui/material';
import { GridRowParams } from '@mui/x-data-grid';
import { memo } from 'react';
import { PointConfig } from '@src/types/PointConfig';
import PCSDetail from './PCSDetail';
import { pcsSx } from '@src/components/_shared/sxStyles/Datatable/deviceTableList';
import PCSConverterContainer from './PCSConverterContainer';
import PCSModuleContainer from './PCSModuleContainer';

interface PCSRow {
  id: GridRowParams['id'];
  name: string;
  [key: string]: PointConfig | string | GridRowParams['id'];
}

interface PCSProps {
  row: PCSRow;
  unitControllerId: string;
  unitControllerEngineeringId: string;
}

const PCSMasterDetail = memo(
  ({ row, unitControllerId, unitControllerEngineeringId }: PCSProps) => (
    <Box sx={pcsSx.detailWrapper}>
      <Stack spacing={2}>
        <PCSDetail
          pcsId={row.id}
          pcsName={row.name}
          unitControllerId={unitControllerId}
          unitControllerEngineeringId={unitControllerEngineeringId}
        />
        <PCSConverterContainer
          pcsId={row.id}
          unitControllerId={unitControllerId}
          unitControllerEngineeringId={unitControllerEngineeringId}
        />
        <PCSModuleContainer
          pcsId={row.id}
          unitControllerId={unitControllerId}
          unitControllerEngineeringId={unitControllerEngineeringId}
        />
      </Stack>
    </Box>
  ),
  (prevProps, nextProps) => {
    return (
      prevProps.row.id === nextProps.row.id &&
      prevProps.unitControllerId === nextProps.unitControllerId &&
      prevProps.unitControllerEngineeringId ===
        nextProps.unitControllerEngineeringId
    );
  },
);

export default PCSMasterDetail;
